// live text chat links
export const CHAT_LINK_TYPES = Object.freeze([
  '',
  'General Chat',
  'Nordstrom Email',
  'Beauty Chat',
  'Beauty Email',
  'Designer Chat',
  'Designer Email',
  'International Chat',
  'International Email',
  'Personal Stylist Chat',
  'Wedding Chat',
  'Wedding Email'
]);

// mods from TableWidget and TableWidgetModal
export const HORIZONTAL_MODE = 'horizontal';
export const VERTICAL_MODE = 'vertical';

// custom entity type for our links
export const LINK_ENTITY_TYPE = 'LINK';

export const ALLOWED_ROWS_COUNT = 20;
export const ALLOWED_COLUMNS_COUNT = 20;
